/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Hosting_TitleInputs */

const fr_legal_hosting_title = /** @type {(inputs: Legal_Hosting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hébergement`)
};

const en_legal_hosting_title = /** @type {(inputs: Legal_Hosting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hosting`)
};

/**
* | output |
* | --- |
* | "Hosting" |
*
* @param {Legal_Hosting_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_hosting_title = /** @type {((inputs?: Legal_Hosting_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Hosting_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_hosting_title(inputs)
	return en_legal_hosting_title(inputs)
});